export const filterOptions = {
  TODAY: 'TODAY',
  YESTERDAY: 'YESTERDAY',
  WEEK: 'WEEK',
  MONTH:'MONTH',
  LAST_WEEK: 'LASTWEEK',
  LAST_MONTH: 'LASTMONTH',
  DAY: 'DAY',
  CURRENT_YEAR: 'CURRENTYEAR',
}
